import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { RouterLink } from '@angular/router';
import { SwitchAccountDropdownComponent } from '../../account-dropdown/account-dropdown/switch-account-dropdown.component';
import { PracticeLocationHeaderComponent } from '../../../../modules/practice-location-header/components/practice-location-header/practice-location-header.component';
import { map, Observable } from 'rxjs';
import { SelectedLocationType } from '../../../enums/selected-location-type.enum';
import { MenuLogoComponent } from '../../../../shared/components/menu-logo/menu-logo.component';
import { Select } from '@ngxs/store';
import { CurrentAccountState } from 'src/states/current-account/current-account.state';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, SharedModule, RouterLink, SwitchAccountDropdownComponent, PracticeLocationHeaderComponent, MenuLogoComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  @Select(CurrentAccountState.type)
  public selectedLocationType$!: Observable<SelectedLocationType>;

  @HostBinding('class.theme-dark') public isDarkTheme$: Observable<boolean> = this.selectedLocationType$.pipe(
    map(locationType => !!locationType && locationType !== SelectedLocationType.Iop)
  );
}
